/* eslint-disable */
import React from "react";
import {
  ArrowDownTrayIcon,
  DocumentArrowDownIcon,
  BuildingOffice2Icon,
  CheckBadgeIcon,
} from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

export default function DetailsOrderExporting() {
  const { t } = useTranslation();

  return (
    <div className="p-6 bg-white dark:!bg-[#181819]">
      {/* header */}
      <div className="flex items-start gap-4 mb-6">
        <div className="rounded-xl border border-[#fbf4ff] dark:!border-[#3c3a3d] p-3 w-16 h-16 flex items-center justify-center bg-purple-50 dark:!bg-[#2a2a2a] shrink-0">
          <ArrowDownTrayIcon className="w-8 h-8 text-[#9e68ba]" />
        </div>
        <div>
          <h3 className="text-xl font-bold text-[#9e68ba] dark:!text-[#b48acb] mb-1">
            {t("services.services.order_exporting.name")}
          </h3>
          <p className="text-sm text-gray-500 dark:!text-gray-400">
            {t("services.order_exporting.details_subtitle")}
          </p>
        </div>
      </div>

      {/* main description */}
      <div className="mb-8">
        <p className="text-gray-700 dark:!text-gray-300 leading-relaxed">
          {t("services.order_exporting.details_description")}
        </p>
      </div>

      {/* features grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
        <div className="bg-purple-50 dark:!bg-[#2a2a2a] rounded-xl p-4 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
          <div className="flex items-center gap-3 mb-2">
            <BuildingOffice2Icon className="w-6 h-6 text-[#9e68ba]" />
            <h4 className="font-semibold text-gray-800 dark:!text-gray-200">
              {t("services.order_exporting.feature_multi_title")}
            </h4>
          </div>
          <p className="text-sm text-gray-600 dark:!text-gray-400">
            {t("services.order_exporting.feature_multi_desc")}
          </p>
        </div>

        <div className="bg-purple-50 dark:!bg-[#2a2a2a] rounded-xl p-4 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
          <div className="flex items-center gap-3 mb-2">
            <DocumentArrowDownIcon className="w-6 h-6 text-[#9e68ba]" />
            <h4 className="font-semibold text-gray-800 dark:!text-gray-200">
              {t("services.order_exporting.feature_format_title")}
            </h4>
          </div>
          <p className="text-sm text-gray-600 dark:!text-gray-400">
            {t("services.order_exporting.feature_format_desc")}
          </p>
        </div>

        <div className="bg-purple-50 dark:!bg-[#2a2a2a] rounded-xl p-4 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
          <div className="flex items-center gap-3 mb-2">
            <CheckBadgeIcon className="w-6 h-6 text-[#9e68ba]" />
            <h4 className="font-semibold text-gray-800 dark:!text-gray-200">
              {t("services.order_exporting.feature_toggle_title")}
            </h4>
          </div>
          <p className="text-sm text-gray-600 dark:!text-gray-400">
            {t("services.order_exporting.feature_toggle_desc")}
          </p>
        </div>

        <div className="bg-purple-50 dark:!bg-[#2a2a2a] rounded-xl p-4 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
          <div className="flex items-center gap-3 mb-2">
            <ArrowDownTrayIcon className="w-6 h-6 text-[#9e68ba]" />
            <h4 className="font-semibold text-gray-800 dark:!text-gray-200">
              {t("services.order_exporting.feature_ready_title")}
            </h4>
          </div>
          <p className="text-sm text-gray-600 dark:!text-gray-400">
            {t("services.order_exporting.feature_ready_desc")}
          </p>
        </div>
      </div>

      {/* how does it work */}
      <div className="bg-gradient-to-r from-purple-50 to-white dark:!from-[#2a2a2a] dark:!to-[#181819] rounded-xl p-5 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
        <h4 className="font-semibold text-gray-800 dark:!text-gray-200 mb-4">
          {t("services.order_exporting.steps_title")}
        </h4>
        <ol className="space-y-3 text-sm text-gray-600 dark:!text-gray-400 list-decimal list-inside">
          <li>{t("services.order_exporting.step_1")}</li>
          <li>{t("services.order_exporting.step_2")}</li>
          <li>{t("services.order_exporting.step_3")}</li>
          <li>{t("services.order_exporting.step_4")}</li>
        </ol>
      </div>
    </div>
  );
}
